export const getProjectDetailsGingerTriggerId = () => `projectDetailsGingerTrigger`;
